import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import InfoConfirmation from './InfoConfirmation';
import PaymentConfirmation from './PaymentConfirmation';
import StepTitle from './StepTitle';
import {
  INSTANCE_CATEGORY,
  PAYMENT_TYPES,
  PLAN_LIST,
} from '../../../constants';
import Text from '../../elements/text/Text';

const Confirmation = ({ billingInfo, card }) => {
  const { t } = useTranslation();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const { getValues } = useFormContext();
  const { plan } = getValues();

  const selectedPlan =
    plan === INSTANCE_CATEGORY.COMMUNITY
      ? PLAN_LIST[0]
      : PLAN_LIST.slice(1).find((pl) => {
          return pl.type === plan;
        });

  const isInvoicePayment = billingInfo?.paymentType === PAYMENT_TYPES.INVOICE;

  return (
    <section>
      <StepTitle title={t('confirmInfoBelow', { ns: 'descriptions' })} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: isSmallScreen ? 'column' : 'row',
          gap: 2,
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Text subtitle color="primary" align="center">
            {t('instanceInfo', { ns: 'instance' })}
          </Text>
          <Divider />
          <InfoConfirmation selectedPlan={selectedPlan} />
        </Box>
        <Box sx={{ flex: 1 }}>
          <Text id="payment-details" subtitle color="primary" align="center">
            {t('paymentDetails', { ns: 'instance' })}
          </Text>
          <Divider />
          <PaymentConfirmation
            card={card}
            isInvoicePayment={isInvoicePayment}
            selectedPlan={selectedPlan}
          />
        </Box>
      </Box>
    </section>
  );
};

Confirmation.propTypes = {
  billingInfo: PropTypes.object,
  card: PropTypes.object,
};

export default Confirmation;
